export const SALES_FUNNEL_STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "following_up", label: "Following up" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
] as const;

export type SalesFunnelStatus = (typeof SALES_FUNNEL_STATUSES)[number]["value"];

export type SalesCrmEventType = "note" | "status_change" | "sms";

export type SalesCrmEvent = {
  id: string;
  business_id: string;
  event_type: SalesCrmEventType | string;
  body: string | null;
  from_status: string | null;
  to_status: string | null;
  phone: string | null;
  created_by: string | null;
  created_at: string;
};

export function normalizeSalesFunnelStatus(value: string | null | undefined): SalesFunnelStatus {
  const v = String(value || "new").trim().toLowerCase();
  if (SALES_FUNNEL_STATUSES.some((s) => s.value === v)) return v as SalesFunnelStatus;
  return "new";
}

export function salesFunnelLabel(value: string | null | undefined): string {
  const normalized = normalizeSalesFunnelStatus(value);
  return SALES_FUNNEL_STATUSES.find((s) => s.value === normalized)?.label ?? "New";
}

export function salesCrmEventTitle(event: SalesCrmEvent): string {
  if (event.event_type === "status_change") {
    return `Stage: ${salesFunnelLabel(event.from_status)} → ${salesFunnelLabel(event.to_status)}`;
  }
  if (event.event_type === "sms") {
    return event.phone ? `SMS to ${event.phone}` : "SMS sent";
  }
  return "Note";
}
